export const currentTrainingSelector = (state: any) => state.currentTraining;
